import { useAuthInfo } from '@propelauth/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { AlertDialog } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/select-project')({
	component: function SelectProject() {
		const { orgHelper } = useAuthInfo();
		const navigate = useNavigate({ from: '/select-project' });

		const authOrgs = orgHelper?.getOrgs();

		const selectProject = (orgId: string) => {
			localStorage.setItem('activeOrgId', orgId);
			navigate({ to: '/' });
		};

		if (authOrgs?.length === 1) {
			selectProject(authOrgs[0].orgId);
			return <LoadingSpinner />;
		}

		return (
			<div className="container mx-0 space-y-4 px-0">
				<Card>
					<CardHeader>
						<CardTitle>Select a Project</CardTitle>
					</CardHeader>
					<CardContent className="flex flex-col gap-4">
						{authOrgs?.map((org) => (
							<Button
								key={org.orgId}
								variant="secondary"
								className="w-fit min-w-60"
								onClick={() => selectProject(org.orgId)}
							>
								{org.orgName}
							</Button>
						))}
						{authOrgs?.length === 0 && <AlertDialog>No projects found</AlertDialog>}
					</CardContent>
				</Card>
			</div>
		);
	},
});
